import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import FormProducto from "./FormProducto";
import { toggleActivoProducto } from "../services/api";
import 'quill/dist/quill.snow.css';
import { formatPrice } from '../utils/format';

function ProductosPage() {
  const [productos,       setProductos]       = useState([]);
  const [categorias,      setCategorias]      = useState([]);
  const [filterText,      setFilterText]      = useState("");
  const [errorMsg,        setErrorMsg]        = useState("");
  const [showForm,        setShowForm]        = useState(false);
  const [productoEditando, setProductoEditando] = useState(null);
  const API_URL = `${process.env.REACT_APP_API_URL}/api`;

  const fetchProductos = async () => {
    try {
      const res = await axios.get(`${API_URL}/productos/all`);
      setProductos(res.data);
    } catch (error) {
      console.error(error);
      setErrorMsg("❌ Error al cargar productos.");
    }
  };

  const fetchCategorias = async () => {
    try {
      const res = await axios.get(`${API_URL}/categorias/all`);
      setCategorias(res.data);
    } catch {
      console.error("Error al cargar categorías");
    }
  };

  useEffect(() => {
    fetchProductos();
    fetchCategorias();
  }, []);

  const handleEditar = (producto) => {
    setProductoEditando(producto);
    setShowForm(true);
  };

  const handleToggleActivo = async (producto) => {
    const accion = producto.activo === false ? "habilitar" : "deshabilitar";
    if (!window.confirm(`¿${accion.charAt(0).toUpperCase() + accion.slice(1)} "${producto.nombre}"?`)) return;
    try {
      await toggleActivoProducto(producto.id);
      fetchProductos();
    } catch {
      alert("Error al cambiar estado del producto");
    }
  };

  const handleCerrarForm = () => { setShowForm(false); setProductoEditando(null); };
  const handleSuccess    = () => { handleCerrarForm(); fetchProductos(); };

  const productosFiltrados = productos.filter((p) => {
    const texto = filterText.toLowerCase();
    return (
      p.nombre?.toLowerCase().includes(texto) ||
      p.descripcion?.toLowerCase().includes(texto) ||
      p.nombreCategoria?.toLowerCase().includes(texto)
    );
  });

  const columns = [
    { name: "ID",       selector: (row) => row.id,                                      sortable: true, width: "65px" },
    {
      name: "Estado",
      selector: (row) => row.activo,
      cell: (row) => (
        <span style={{
          padding: "2px 8px", borderRadius: 10, fontSize: 11, fontWeight: 600,
          backgroundColor: row.activo === false ? "#fee2e2" : "#dcfce7",
          color: row.activo === false ? "#991b1b" : "#166534",
        }}>
          {row.activo === false ? "Inactivo" : "Activo"}
        </span>
      ),
      width: "90px",
    },
    { name: "Nombre",   selector: (row) => row.nombre,                                  sortable: true },
    {
      name: "Descripción",
      cell: (row) => (
        <div
          className="ql-editor"
          style={{ padding: '4px 0', fontSize: 13, maxWidth: 300 }}
          dangerouslySetInnerHTML={{ __html: row.descripcion || '' }}
        />
      ),
      wrap: true,
    },
    { name: "Precio",   selector: (row) => row.precio, cell: (row) => `$${formatPrice(row.precio)} + IVA`, sortable: true, width: "120px" },
    { name: "Stock",    selector: (row) => row.stock,                                   sortable: true, width: "75px" },
    { name: "Categoría", selector: (row) => row.nombreCategoria || "Sin categoría",     sortable: true },
    {
      name: "Acciones",
      cell: (row) => (
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
          <button onClick={() => handleEditar(row)}
            style={btnStyle("#1a1a2e", "#fff")}>
            ✏️ Editar
          </button>
          <button onClick={() => handleToggleActivo(row)}
            style={btnStyle(row.activo === false ? "#166534" : "#991b1b", "#fff")}>
            {row.activo === false ? "✅ Habilitar" : "🚫 Deshabilitar"}
          </button>
        </div>
      ),
      ignoreRowClick: true,
      minWidth: "210px",
    },
  ];

  const subHeaderComponent = (
    <input
      type="text" placeholder="🔍 Buscar producto..."
      value={filterText} onChange={(e) => setFilterText(e.target.value)}
      style={{ padding: "6px 10px", width: "250px", borderRadius: "4px", border: "1px solid #ccc" }}
    />
  );

  return (
    <div style={{ padding: "20px" }}>
      <h2>🛒 Gestión de Productos</h2>

      {!showForm && (
        <button onClick={() => { setProductoEditando(null); setShowForm(true); }}
          style={{ padding: "8px 16px", marginBottom: 12, cursor: "pointer" }}>
          ➕ Crear Producto
        </button>
      )}

      {showForm && (
        <FormProducto
          key={productoEditando?.id ?? "nuevo"}
          productoEditando={productoEditando}
          categorias={categorias}
          onCancel={handleCerrarForm}
          onSuccess={handleSuccess}
        />
      )}

      <h3 style={{ marginTop: "30px" }}>📋 Listado de Productos</h3>
      {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}

      <DataTable
        columns={columns}
        data={productosFiltrados}
        pagination
        highlightOnHover
        striped
        responsive
        noDataComponent="No hay productos disponibles"
        subHeader
        subHeaderComponent={subHeaderComponent}
        conditionalRowStyles={[{
          when: row => row.activo === false,
          style: { opacity: 0.5 },
        }]}
      />
    </div>
  );
}

const btnStyle = (bg, color) => ({
  padding: "3px 8px", backgroundColor: bg, color,
  border: "none", borderRadius: 4, cursor: "pointer", fontSize: 12,
});

export default ProductosPage;
